import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.button`
  background: ${theme.colors.gray17};
  border-radius: ${theme.unit}px;
  border: 0;
  box-sizing: border-box;
  color: ${theme.colors.gray3};
  cursor: pointer;
  font-family: inherit;
  font-size: ${theme.unit * 1.875}px;
  font-weight: 400;
  height: ${theme.unit * 6}px;
  line-height: ${theme.unit * 6}px;
  margin: 0 ${theme.unit / 2}px;
  outline: 0;
  padding: 0 ${theme.unit * 2}px;
  position: relative;
  text-align: center;
  transition: all 150ms ease 0s;
  width: ${props => (props.fluid ? '100%' : 'auto')};

  &:hover {
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, .1);
  }

  &:focus {
    &::before {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: ${theme.unit}px;
      box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.25);
      pointer-events: none;
    }
  }

  &:active {
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, .1);
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &[disabled] {
    background: ${theme.colors.gray16};
    color: ${theme.colors.gray1};
    cursor: default;
    opacity: .3;

    &:active,
    &:hover {
      box-shadow: none;
    }
  }

  ${({ bold }) => bold && `
    font-weight: 600;
  `}

  ${({ standard }) => standard && `
    min-width: ${theme.unit * 21}px;
  `}

  ${({ fixed }) => fixed && `
    min-width: ${theme.unit * 14}px;
  `}

  ${({ small }) => small && `
    height: ${theme.unit * 5.5}px;
    line-height: ${theme.unit * 5.5}px;
  `}

  ${({ mini }) => mini && `
    font-size: ${theme.unit * 1.725}px;
    text-transform: uppercase;
    height: ${theme.unit * 3}px;
    line-height: ${theme.unit * 3}px;
    padding: 0 ${theme.unit * 1.5}px;
    margin: 0 ${theme.unit / 4}px;
  `}

  ${({ active }) => active && `
    color: ${theme.colors.active};

    &::before,
    &:focus::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset 0 0 0 2px ${theme.colors.active};
      border-radius: ${theme.unit}px;
    }
  `}
`.withComponent(({
    fluid, bold, standard, fixed, small, active, inverse, mini, // strip
    ...props
  }) => <button {...props} />,
));



// WEBPACK FOOTER //
// ./src/components/buttons/Button.js